import * as PIXI from 'pixi.js'
import PropTypes from 'prop-types'

import app from 'common/builder/components/chart/FlowChart/app'
import PixiObject from 'common/builder/components/chart/FlowChart/pixi-object'

export default class BackgroundLayer extends PixiObject {
  static propTypes = {
    selected: PropTypes.object,
  }

  createObject() {
    const container = new PIXI.Container()
    container.id = 'background'
    app.setNode(container)
    return container
  }

  rerender() {}
}
